import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { NAV, WA_LINK } from "./data";
import { WaIcon } from "./Reveal";

const SERVICES = ["Internet Rumah", "WiFi Bisnis", "Solusi Jaringan", "Area Baru"];

const FootCol = ({ title, children }) => (
  <div>
    <p className="font-tag text-xs uppercase tracking-widest text-sky-300">{title}</p>
    <ul className="mt-5 space-y-3 text-sm">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#041050] text-blue-100 overflow-hidden">
    <div className="h-1 bg-gradient-to-r from-red-500 via-vblue to-emerald-400" />
    <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-vblue/30 blur-3xl" />
    <div className="absolute -bottom-40 right-0 w-96 h-96 rounded-full bg-emerald-500/20 blur-3xl" />
    <div className="relative max-w-[1320px] mx-auto px-5 lg:px-10 pt-16 pb-8">
      <div className="grid sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-10">
        <div>
          <div className="inline-block"><Logo light /></div>
          <p className="mt-5 text-sm leading-relaxed max-w-xs">Internet cepat, stabil dan terjangkau untuk rumah, usaha dan seluruh kabupaten di Kalimantan Barat.</p>
        </div>
        <FootCol title="Menu">
          {NAV.map((n) => <li key={n.label}><a href={n.href} className="hover:text-white hover:pl-1 transition-[padding,color] duration-300">{n.label}</a></li>)}
        </FootCol>
        <FootCol title="Layanan">
          {SERVICES.map((s) => <li key={s}><a href="#layanan" className="hover:text-white transition-colors">{s}</a></li>)}
        </FootCol>
        <FootCol title="Kontak">
          <li>WhatsApp: <span className="text-white font-semibold">0852-8000-0955</span></li>
          <li>Area: <span className="text-white font-semibold">Kalimantan Barat</span></li>
          <li className="pt-2"><a href={WA_LINK} target="_blank" rel="noreferrer" data-testid="footer-wa-btn" className="btn-wa btn-shine inline-flex items-center gap-2 !py-2.5 !px-5 text-sm"><WaIcon /> Chat WhatsApp</a></li>
        </FootCol>
      </div>
      <p aria-hidden="true" className="font-tag uppercase text-outline text-[13vw] lg:text-[150px] leading-none mt-14 opacity-40 select-none whitespace-nowrap">Vision</p>
      <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-sm">
        <p>© {new Date().getFullYear()} PT. Vision Mega Network</p>
        <p>Internet Murah Untuk Masyarakat Kalimantan Barat</p>
      </div>
    </div>
  </footer>
);

export const FloatingWa = () => (
  <motion.a
    href={WA_LINK}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-wa-btn"
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    transition={{ delay: 2, type: "spring" }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#1aa34a] text-white grid place-items-center shadow-[0_14px_30px_-8px_rgba(26,163,74,0.9)]"
    aria-label="WhatsApp"
  >
    <span className="absolute inset-0 rounded-full bg-[#1aa34a] animate-ping opacity-30" />
    <WaIcon className="w-7 h-7 relative" />
  </motion.a>
);
